define([
	"dojo/_base/declare",
	"csi/widget/ComboBox",
	"./StringSelection"
], function(declare,ComboBox,StringSelection) {

	return declare(StringSelection, {
		// use TextController to handle ComboBox
		ignoreInvalid: true,
		tagAction: "ActionString",
		widgetClass: ComboBox
	});
});